module.exports = __webpack_public_path__ + "static/img/ic_default_avatar.9c2679a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_default_avatar.png
// module id = 9cAu
// module chunks = 1